import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { LayerType } from '@/version-types';
import { type ImageLayer } from '../../index';

export const backgroundSetItem = (
    { activeLayer, pickLayer, operateLayerType, isImageEditor }: IRenderContextMenuItemArgs,
    identity: string,
) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (!layer) return null;
    if (isImageEditor) return null;
    if (operateLayerType !== LayerType.IMAGE_LAYER) return null;
    if (!framework.service.flatLayer.checkPossibleSplit(layer)) return null;
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.backgroundSet),
        type: 'backgroundSet',
        icon: 'BecomeBackgroundBold',
        onClick: () => {
            const imageLayer = framework.service.registration.getInstance<ImageLayer>('ImageLayer');
            if (!imageLayer) {
                throw new Error('ImageLayer is not found');
            }
            imageLayer.convertImageToBackground(
                layer.id,
                framework.service.flatLayer.checkIsGroup(layer),
                framework.service.flatLayer.checkIsTextMaterialVip(activeLayer) ? activeLayer?.materialIds : undefined,
            );
        },
    };
    return item;
};
